<template>
  <form @submit.prevent="save">
    <v-container fluid>
      <v-card-text>
        Your password must consist of At least 8 characters, A mixture of both uppercase and lowercase letters, and A mixture of letters and numbers.
      </v-card-text>
      <v-card-text>
        <v-text-field
          v-model="form.password"
          label="New Password"
          outlined
          :class="{ 'is-invalid': form.errors.password }"
          class="form-control"
          name="password"
          :error="form.errors.password === true"
          :error-messages="form.errors.password"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPassword ? 'text' : 'password'"
          @click:append="showPassword = !showPassword"
        />
      </v-card-text>
      <v-card-text>
        <v-text-field
          v-model="form.password_confirmation"
          label="Confirm New Password"
          outlined
          :class="{ 'is-invalid': form.errors.password_confirmation }"
          class="form-control"
          name="password_confirmation"
          :error="form.errors.password_confirmation"
          :error-messages="form.errors.password_confirmation"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPassword ? 'text' : 'password'"
          @click:append="showPassword = !showPassword"
        />
      </v-card-text>
      <v-card-actions>
        <inertia-link class="v-btn v-btn--flat v-btn--text theme--light v-size--small primary--text" :href="route('login')" method="get">
          Back to Login
        </inertia-link>
        <v-spacer />
        <v-btn
          depressed
          :loading="loading"
          color="primary"
          type="submit"
        >
          Update Password
        </v-btn>
      </v-card-actions>
    </v-container>
  </form>
</template>

<script>
import Layout from '@/Layouts/Basic'

export default {
   metaInfo: { title: 'Login' },
   components: {
      //
   },
   layout: (h, page) => h(Layout, [page]),

   props: {
      email: {
         type: String,
         required: true,
      },
      token: {
         type: String,
         required: true,
      },
   },

   data () {
      return {
         loading: false,
         showPassword: false,
         form: this.$inertia.form({
            email: null,
            password: null,
            password_confirmation: null,
         }),
      }
   },
   methods: {
      save () {
         this.loading = true
         this.$inertia.post(this.route('password.update'), { email: this.email, token: this.token, password: this.form.password, password_confirmation: this.form.password_confirmation }).then(() => this.loading = false)
      },
   },
}
</script>
